import React from 'react';

/**
 * Fångar renderingsfel så att ett trasigt delträd inte lämnar användaren
 * med en vit skärm.
 */
export default class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false };
  }

  static getDerivedStateFromError() {
    return { hasError: true };
  }

  componentDidCatch(error, info) {
    console.error('Renderingsfel:', error, info);
  }

  render() {
    if (!this.state.hasError) return this.props.children;

    return (
      <div className="error-boundary">
        <h2>Något gick fel</h2>
        <p className="muted">Ladda om sidan så försöker vi igen.</p>
        <button className="btn btn--primary" onClick={() => window.location.reload()}>
          Ladda om
        </button>
      </div>
    );
  }
}
